





































































































































































































































































import { readStructureResponse, readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { dispatchGetMyStructureUsers, dispatchGetWaitingUsers } from '@/store/main/actions';
import WriteThroughChatbot from '@/components/UserDetails/Modals/WriteThroughChatbot.vue';
import CreateLeadModal from '@/components/Team/Modals/CreateLeadModal.vue';
import CreatePartnerModal from '@/components/Team/Modals/CreatePartnerModal.vue';
import LeadSettingsModal from '@/components/Team/Modals/LeadSettingsModal.vue';
import ManualDonationModal from '@/components/Team/Modals/ManualDonationModal.vue';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';

@Component({
  components: {
    FmvAvatar,
    WriteThroughChatbot,
    CreateLeadModal,
    CreatePartnerModal,
    CustomSelectInput,
    LeadSettingsModal,
    ManualDonationModal,
  },
})
export default class MyStructureTable extends Vue {
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public viewAs: number | null;
  public search = '';
  public currentPage = 1;
  public perPage = 6;
  public loadingState = {
    list: false,
    submit: false,
  };
  public createLeadModal: boolean = false;
  public createPartnerModal: boolean = false;
  public showGiveAwayModal: boolean = false;
  public giveAwayConsultantID: number | null = null;
  public giveAwayUserID: number | null = null;
  public writeTelegramModal: boolean = false;
  public writeTelegramUserId: any = null;
  public leadSettingsModal: boolean = false;
  public leadSettings: any = null;
  public donationModal: boolean = false;
  public rejectOpen: boolean = false;
  public donationLeadID: number | null = null;
  public groupIds: any = null;

  public async mounted() {
    this.loadingState.list = true;
    await dispatchGetMyStructureUsers(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {search: this.search, view_user_id: this.viewAs, group: this.groupIds},
      },
    );
    this.loadingState.list = false;
  }

  get usersList() {
    return readStructureResponse(this.$store);
  }

  public async handleSearchUser() {
    this.loadingState.list = true;
    this.currentPage = 1;
    const data = {
      search: this.search,
      view_user_id: this.viewAs,
      group: this.groupIds,
    };
    await dispatchGetMyStructureUsers(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data,
      },
    );
    this.loadingState.list = false;
  }

  public async handleChangePage(page) {
    this.loadingState.list = true;
    this.currentPage = page;
    await dispatchGetMyStructureUsers(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {search: this.search, view_user_id: this.viewAs, group: this.groupIds},
      },
    );
    this.loadingState.list = false;
  }

  public handleRowClick(item, index, event) {
    setTimeout(() => {
      if (this.leadSettingsModal || this.showGiveAwayModal || this.writeTelegramModal ||
          this.donationModal || this.rejectOpen) {
        return null;
      }
      if (this.viewAs) {
        return null;
      }
      // const userProfile = readUserProfile(this.$store);
      // @ts-ignore
      // if (userProfile.groups.includes('Менеджеры - Консультирование') ||
      //     // @ts-ignore
      //     this.isSupervisor || userProfile.groups.includes('Менеджеры - Партнерство')) {
      this.$router.push(`/user/view-details/${item.pk}`);
    }, 300);
  }

  public handleOpenTelegram(item) {
    if (item.tg_username !== null) {
      if (item.tg_username) {
        window.open(`https://t.me/${item.tg_username}`, '_blank');
      } else {
        this.writeTelegramUserId = item.pk;
        this.writeTelegramModal = true;
      }
    }
  }

  public handleCloseTelegramModal() {
    this.writeTelegramModal = false;
    this.writeTelegramUserId = null;
  }

  public handleCloseCreateLeadModal() {
    this.createLeadModal = false;
  }

  public handleOpenPartnerEditForm(user=null) {
    this.leadSettings = user;
    this.createPartnerModal = true;
  }

  public handleCloseCreatePartnerModal() {
    this.createPartnerModal = false;
    this.leadSettings = null;
  }

  public handleLeadCreated() {
    this.handleChangePage(this.currentPage);
    this.createLeadModal = false;
  }

  public handlePartnerCreated() {
    this.handleChangePage(this.currentPage);
    this.createPartnerModal = false;
    this.leadSettings = null;
  }

  public resetGiveAwayForm() {
    this.showGiveAwayModal = false;
    this.giveAwayConsultantID = null;
    this.giveAwayUserID = null;
  }

  public handleOpenGiveAwayForm(userID) {
    this.showGiveAwayModal = true;
    this.giveAwayUserID = userID;
  }

  // public handleOpenLeadSettingsForm(user) {
  //   this.leadSettings = user;
  //   this.leadSettingsModal = true;
  // }
  // public handleCloseLeadSettingsModal() {
  //   this.leadSettingsModal = false;
  //   this.leadSettings = null;
  // }
  // public handleLeadSettingsUpdated() {
  //   this.handleCloseLeadSettingsModal();
  //   this.handleChangePage(this.currentPage);
  // }

  public handleRejectUser(userID) {
    // deprecated
    this.rejectOpen = true;
    // @ts-ignore
    this.$swal({
      // @ts-ignore
      title: this.$t('Do you confirm rejection?'),
      // icon: 'warning',
      buttons: {
        cancel: {
          // @ts-ignore
          text: this.$t('Cancel'),
          value: false,
          visible: true,
          className: 'btn btn-secondary',
          closeModal: true,
        },
        confirm: {
          // @ts-ignore
          text: this.$t('Confirm'),
          value: true,
          visible: true,
          className: 'btn btn-primary',
          closeModal: true,
        },
      },
    }).then(async (value) => {
      if (value) {
        try {
          const response = await api.rejectResponsibleUser(
            this.$store.getters.token, {user_id: userID},
          );
          // @ts-ignore
          this.showToast(this, this.$t('User rejected successfully'));
          this.handleChangePage(this.currentPage);
          dispatchGetWaitingUsers(
            this.$store, {
              rowQuery: `?page=${1}&page_size=${6}`,
              data: {search: ''},
            },
          );
          this.rejectOpen = false;
        } catch (e) {
          // @ts-ignore
          if (e.response.data && e.response.data.user_id) {
            // @ts-ignore
            this.showToast(this, e.response.data.user_id[0], 'error');
          } else {
            // @ts-ignore
            this.showToast(this, this.$t('Error'), 'error');
            this.rejectOpen = false;
          }
        }
      }
    });
  }

  public handleOpenGeneralDonationForm() {
    this.donationLeadID = null;
    this.donationModal = true;
  }
  public handleOpenDonationForm(userID) {
    this.donationLeadID = userID;
    this.donationModal = true;
  }
  public handleCloseDonationModal() {
    this.donationModal = false;
    this.donationLeadID = null;
    this.$emit('donations-event');
  }

  public handleChangeConsultant(value) {
    // const newList: any = [];
    // for (const [key, val] of Object.entries(value)) {
    //   // @ts-ignore
    //   newList.push(val.id);
    // }
    this.giveAwayConsultantID = value;
  }

  public async handleSubmitGiveAwayUser() {
    if (!this.giveAwayConsultantID || !this.giveAwayUserID || this.giveAwayConsultantID === this.giveAwayUserID) {
      // @ts-ignore
      this.showToast( this, this.$t('Please, select consultant'), 'error');
      return null;
    }
    this.loadingState.submit = true;
    try {
      const response = await api.submitGiveAwayUser(
        // @ts-ignore
        this.$store.getters.token, {consultant_id: this.giveAwayConsultantID, user_id: this.giveAwayUserID},
      );
      this.handleChangePage(this.currentPage);
      this.resetGiveAwayForm();
      // @ts-ignore
      this.showToast( this, this.$t('Operation successful'));
    } catch (e) {
      // @ts-ignore
      this.showToast( this, this.$t('Error'), 'error');
    }
    this.loadingState.submit = false;
  }

  get usersFields() {
    return [
      {
        key: 'tg_username',
        label: '',
        sortable: false,
        class: 'width-1',
      },
      {
        key: 'first_name',
        label: this.$t('Name'),
        sortable: false,
      },
      {
        key: 'phone',
        label: this.$t('Phone'),
        sortable: false,
      },
      {
        key: 'country_with_flag',
        label: this.$t('Country'),
        sortable: false,
      },
      {
        key: 'date_joined',
        label: this.$t('Date joined'),
        sortable: false,
      },
    ];
  }

  public checkGroups(groups) {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

  get isSupervisor() {
    const groups = ['Руководитель отдела консультантов', 'Админы'];
    return this.checkGroups(groups);
  }

  public handleChangeGroup(value) {
    // const newList: any = [];
    // for (const [key, val] of Object.entries(value)) {
    //   // @ts-ignore
    //   newList.push(val.id);
    // }
    this.groupIds = value;
    this.handleSearchUser();
  }

  get isDonationAvailable() {
    // const groups = ['Менеджеры - Партнерство'];
    // const userProfile = readUserProfile(this.$store);
    // if (userProfile) {
    //   for (const [key, value] of Object.entries(groups)) {
    //     // @ts-ignore
    //     if (userProfile.groups.includes(value)) {
    //       return true;
    //     }
    //   }
    // }
    return true;
  }

  get available() {
    if (this.viewAs) {
      return true;
    }
    const groups = [
      'Менеджеры - Консультирование', 'Менеджеры - Партнерство',
      'Руководитель отдела консультантов', 'Админы',
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
      "Менеджер отдела консультирования",
      "Менеджер партнерского отдела",
      "Консультант отдела консультирования",
      "Консультант партнерского отдела",
    ];
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
